<template>
  <div class="app">
    <div class="bg_index">
      <!--轮播图-->
      <productBanner :Product="product" class="bannerFather"></productBanner>

      <div class="others"></div>
      <!-- 典型场景降噪方案体验 -->
      <Case></Case>
      <div class="others"></div>

      <!-- 技术亮点 -->
      <div class="Technical">
        <h4>产品亮点</h4>
        <div>
          <div v-for="(item, index) in cardMsg" :key="index" class="tech-box">
            <div
              class="left"
              :style="{ background: 'url(' + require('@/assets/' + item['img']) + ') no-repeat center center'}"
            ></div>
            <div class="right">
              <div>
                <p v-for="(ite, ind) in item['p']" :key="ind">{{ite}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <TechnicalHighlights :list="techDes"></TechnicalHighlights> -->

      <!-- 使用场景 -->
      <suitCase :list="suit" class="suitcase"></suitCase>

      <!-- 下载彩页 -->
      <div class="sccyUp">
        <productDownload :product="download"></productDownload>
      </div>

      <div class="sccyUp"></div>
      <div style="background-color: white;" id="submit">
        <cooperateForm class="submitform"></cooperateForm>
      </div>
      <!-- 商务合作 -->
      <div class="footblack" />
    </div>
  </div>
</template>

<script>
import cooperateForm from '@/components/common/cooperateForm'
import suitCase from '@/components/common/suitCase'
import coreCardRight from '@/components/common/coreCardRight'
import TechnicalHighlights from '@/components/common/TechnicalHighlights'
import productDownload from '@/components/common/productDownload'
import Case from './case'
import productBanner from '@/components/common/productBanner'
// import { BaseURL } from '@/api/http.js'
export default {
  data () {
    return {
      download: '彩页图',
      suit: [
        { 'img': 'images/chanpin/rs_bot1.png', 'context': ['用于音频信息分析、执法与司法取证、', '新闻采编、音频媒体文件存档和恢复'] },
        { 'img': 'images/chanpin/rs_bot2.png', 'context': ['可集成到高端拾音器、智能硬件', '和特殊通信设备中提高录音或通话质量'] }
      ],
      techDes: [
        { 'title': false, 'context': ' 融合了先进的噪声抑制算法<br />能去除连续/非连续、回响、混响背景噪声<br />宽带/窄带信道噪声和压缩后失真', 'img': 'images/rs/rs_js_1.png' },
        { 'title': false, 'context': '过滤参数可根据噪声<br />环境自适应调整', 'img': 'images/rs/rs_js_2.png' },
        { 'title': false, 'context': '支持典型场景降噪方案配置模板<br />简单易用', 'img': 'images/rs/rs_js_3.png' },
        { 'title': false, 'context': '可跨平台部署', 'img': 'images/rs/rs_js_4.png' }
      ],
      product: {
        'background': 'images/chanpin/rs_banner.png',
        'img': 'images/chanpin/rs_ct.png',
        'h2': ['语音降噪与增强系统'],
        'desc': ['专业的噪音抑制和语音增强系统', '融合了先进的滤波算法和语音增强工具'],
        'h3': [],
        'p': ['—音频处理专家', '音频处理与语音特征分析'],
        'product': 'images/chanpin/rs_a.png'
      },
      cardMsg: [{
        'img': 'images/rs/rs_js_10.png',
        'p': ['十余种先进降噪算法，包括性能优异的', '图形化均衡处理算法和独特的噪声对消;', '处理算法；']
      },
      {
        'img': 'images/rs/rs_js_11.png',
        'p': ['十余种场景化预配置降噪方案，用户可', '简单套用即可获得良好的降噪效果；']
      }, {
        'img': 'images/rs/rs_js_12.png',
        'p': ['独特的智能自动降噪，便于处理最常见', '的噪声，适合初学者使用；']
      }, {
        'img': 'images/rs/rs_js_13.png',
        'p': ['可灵活组合的降噪模块形成多样化降噪', '方案，降噪模块数量不受限制，可应对', '不同场景和不同条件下产生的多类型噪', '声；']
      }, {
        'img': 'images/rs/rs_js_14.png',
        'p': ['支持“边调、边看、边听”的即时调试', '模式和多文件处理模式，可满足现场监', '听、实验室专业处理分析等不同需求任', '务；']
      }, {
        'img': 'images/rs/rs_js_15.png',
        'p': ['支持自动语音转录和手动标注功能，便', '于用户对音频信号内容进行分析处理；']
      }, {
        'img': 'images/rs/rs_js_16.png',
        'p': ['提供音频信号噪声智能分析工具，可为', '用户推荐降噪模块应用建议；']
      }, {
        'img': 'images/rs/rs_js_17.png',
        'p': ['支持广泛的音频格式，可以从多种格式', '和编解码器的视频文件中提取音轨；']
      }]
    }
  },
  methods: {
    getWeb () {
      let userAgent = navigator.userAgent
      if ((userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0')) || ((userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1))) {
        this.wavUrl = this.theUrl
        return true
      } else {
        return false
      }
    }
  },
  watch: {
  },
  mounted () {
    const params = this.$route.params
    if (params.hasOwnProperty('ScorldId')) {
      if (params.hasOwnProperty('ScorldId')) {
        if (this.getWeb()) {
          document.documentElement.scrollTop = 600
        } else {
          document.getElementById(params['ScorldId']).scrollIntoView()
        }
      }
    }
  },
  components: {
    cooperateForm: cooperateForm,
    Case: Case,
    TechnicalHighlights,
    suitCase: suitCase,
    productBanner,
    coreCardRight,
    productDownload
  }
}
</script>

<style scoped>
.suitcase {
  background-color: white;
  margin-bottom: -89px;
  padding-bottom: 85px;
}
/* 主体内容 */
.Technical {
  height: 875px;
  width: 1200px;
  background: rgba(248, 248, 248, 1);
}
.Technical h4 {
  font-size: 30px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  margin-top: 95px;
  margin-bottom: 55px;
}
.tech-box {
  width: 530px;
  height: 150px;
  float: left;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 6px 18px 2px rgba(167, 167, 167, 0.2);
  border-radius: 6px;
  margin-bottom: 30px;
  margin-left: 46px;
}
.tech-box .left {
  margin-left: 0px;
  width: 135px;
  height: 100%;
  margin: 0 auto;
  float: left;
  position: relative;
}
.tech-box .right {
  width: 350px;
  height: 100%;
  position: relative;
  margin-left: 135px;
}
.right div {
  border-left: 1px solid rgba(226, 226, 226, 1);
  position: absolute;
  width: 100%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.tech-box .right p {
  font-size: 16px;
  line-height: 30px;
  font-weight: normal;
  color: rgba(51, 51, 51, 1);
  text-align: left;
  padding-left: 40px;
}
.others {
  background-color: white;
  height: 80px;
  width: 100%;
}
.cj {
  padding-top: 105px;
}
#cj {
  margin: 60px auto;
}
/* 提交表单 */
.submitform {
  width: 803px;
  margin-top: 75px;
  margin-bottom: -23px;
  padding-top: 90px;
}
.app .submitform /deep/ .el-input__inner {
  -webkit-appearance: none;
  background: rgba(248, 248, 248, 1);
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: rgba(156, 156, 156, 1);
  display: inline-block;
  font-size: inherit;
  height: 72px;
  line-height: 40px;
  outline: 0;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
  text-align: left;
}
.app .submitform /deep/ .el-textarea__inner {
  display: block;
  resize: vertical;
  padding: 5px 15px;
  line-height: 1.5;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  font-size: 20px;
  color: #606266;
  background-color: rgba(248, 248, 248, 1);
  background-image: none;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  text-align: left;
}

/* 下载彩页开始 */
.sccyUp {
  background: rgba(248, 248, 248, 1);
  height: 80px;
}
.footblack {
  height: 50px;
  width: 100%;
  background: white;
  margin-top: -26px;
}
.bannerFather /deep/ .caiye {
  margin-top: 50px;
}
/* .bannerFather /deep/ .product {
  padding-top: 0px;
} */
.bannerFather /deep/ .product-h2 {
  font-size: 50px;
}
.bannerFather /deep/ .brand {
  width: 45px;
  height: 21px;
  margin-left: 0px;
  margin-top: -55px;
}
/* .bannerFather /deep/ .banner {
  margin-top: -2px !important;
} */
.bannerFather /deep/ .reg {
  font-size: 20px;
  margin-left: 46px;
  margin-top: -68px;
}
.bannerFather /deep/ .desc {
  font-size: 26px;
  margin-top: 30px;
}

.bannerFather /deep/ .desc p {
  line-height: 36px;
}

.bannerFather /deep/ .product-p {
  font-size: 20px;
  font-weight: bold;
  margin-top: 160px;
}
.bannerFather /deep/ .product-p :first-child {
  margin-left: 65px;
  margin-top: -23px;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/solution/Rs/SoundDenoise.vue